[
  {
    "id": "major-0",
    "arcana": "major",
    "suit": "major",
    "number": 0,
    "rank": null,
    "sortOrder": 0,
    "names": {
      "en": "The Fool",
      "es": "El Loco"
    },
    "keywords": {
      "en": [
        "beginnings",
        "innocence",
        "leap of faith",
        "spontaneity",
        "free spirit"
      ],
      "es": [
        "comienzos",
        "inocencia",
        "salto de fe",
        "espontaneidad",
        "espíritu libre"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:0",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/0.webp"
    }
  },
  {
    "id": "major-1",
    "arcana": "major",
    "suit": "major",
    "number": 1,
    "rank": null,
    "sortOrder": 1,
    "names": {
      "en": "The Magician",
      "es": "El Mago"
    },
    "keywords": {
      "en": [
        "will",
        "manifestation",
        "resourcefulness",
        "focus",
        "capability"
      ],
      "es": [
        "voluntad",
        "manifestación",
        "recursos",
        "enfoque",
        "capacidad"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:1",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/1.webp"
    }
  },
  {
    "id": "major-2",
    "arcana": "major",
    "suit": "major",
    "number": 2,
    "rank": null,
    "sortOrder": 2,
    "names": {
      "en": "The High Priestess",
      "es": "La Sacerdotisa"
    },
    "keywords": {
      "en": [
        "intuition",
        "the unspoken",
        "inner knowing",
        "mystery",
        "patience"
      ],
      "es": [
        "intuición",
        "lo no dicho",
        "saber interno",
        "misterio",
        "paciencia"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:2",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/2.webp"
    }
  },
  {
    "id": "major-3",
    "arcana": "major",
    "suit": "major",
    "number": 3,
    "rank": null,
    "sortOrder": 3,
    "names": {
      "en": "The Empress",
      "es": "La Emperatriz"
    },
    "keywords": {
      "en": [
        "creativity",
        "abundance",
        "nurture",
        "fertility",
        "sensuality"
      ],
      "es": [
        "creatividad",
        "abundancia",
        "cuidado",
        "fertilidad",
        "sensualidad"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:3",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/3.webp"
    }
  },
  {
    "id": "major-4",
    "arcana": "major",
    "suit": "major",
    "number": 4,
    "rank": null,
    "sortOrder": 4,
    "names": {
      "en": "The Emperor",
      "es": "El Emperador"
    },
    "keywords": {
      "en": [
        "structure",
        "authority",
        "boundaries",
        "discipline",
        "stability"
      ],
      "es": [
        "estructura",
        "autoridad",
        "límites",
        "disciplina",
        "estabilidad"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:4",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/4.webp"
    }
  },
  {
    "id": "major-5",
    "arcana": "major",
    "suit": "major",
    "number": 5,
    "rank": null,
    "sortOrder": 5,
    "names": {
      "en": "The Hierophant",
      "es": "El Hierofante"
    },
    "keywords": {
      "en": [
        "tradition",
        "teaching",
        "institutions",
        "shared belief",
        "guidance"
      ],
      "es": [
        "tradición",
        "enseñanza",
        "instituciones",
        "creencia compartida",
        "guía"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:5",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/5.webp"
    }
  },
  {
    "id": "major-6",
    "arcana": "major",
    "suit": "major",
    "number": 6,
    "rank": null,
    "sortOrder": 6,
    "names": {
      "en": "The Lovers",
      "es": "Los Enamorados"
    },
    "keywords": {
      "en": [
        "choice",
        "union",
        "values",
        "alignment",
        "attraction"
      ],
      "es": [
        "elección",
        "unión",
        "valores",
        "alineación",
        "atracción"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:6",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/6.webp"
    }
  },
  {
    "id": "major-7",
    "arcana": "major",
    "suit": "major",
    "number": 7,
    "rank": null,
    "sortOrder": 7,
    "names": {
      "en": "The Chariot",
      "es": "El Carro"
    },
    "keywords": {
      "en": [
        "momentum",
        "willpower",
        "direction",
        "control",
        "determination"
      ],
      "es": [
        "impulso",
        "voluntad",
        "dirección",
        "control",
        "determinación"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:7",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/7.webp"
    }
  },
  {
    "id": "major-8",
    "arcana": "major",
    "suit": "major",
    "number": 8,
    "rank": null,
    "sortOrder": 8,
    "names": {
      "en": "Strength",
      "es": "La Fuerza"
    },
    "keywords": {
      "en": [
        "courage",
        "patience",
        "gentle power",
        "composure",
        "self-mastery"
      ],
      "es": [
        "coraje",
        "paciencia",
        "poder suave",
        "temple",
        "dominio propio"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:8",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/8.webp"
    }
  },
  {
    "id": "major-9",
    "arcana": "major",
    "suit": "major",
    "number": 9,
    "rank": null,
    "sortOrder": 9,
    "names": {
      "en": "The Hermit",
      "es": "El Ermitaño"
    },
    "keywords": {
      "en": [
        "solitude",
        "introspection",
        "searching",
        "guidance",
        "withdrawal"
      ],
      "es": [
        "soledad",
        "introspección",
        "búsqueda",
        "guía",
        "retiro"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:9",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/9.webp"
    }
  },
  {
    "id": "major-10",
    "arcana": "major",
    "suit": "major",
    "number": 10,
    "rank": null,
    "sortOrder": 10,
    "names": {
      "en": "Wheel of Fortune",
      "es": "La Rueda de la Fortuna"
    },
    "keywords": {
      "en": [
        "cycles",
        "turning point",
        "luck",
        "fate",
        "change"
      ],
      "es": [
        "ciclos",
        "punto de giro",
        "suerte",
        "destino",
        "cambio"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:10",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/10.webp"
    }
  },
  {
    "id": "major-11",
    "arcana": "major",
    "suit": "major",
    "number": 11,
    "rank": null,
    "sortOrder": 11,
    "names": {
      "en": "Justice",
      "es": "La Justicia"
    },
    "keywords": {
      "en": [
        "fairness",
        "consequence",
        "truth",
        "accountability",
        "balance"
      ],
      "es": [
        "equidad",
        "consecuencia",
        "verdad",
        "responsabilidad",
        "balance"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:11",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/11.webp"
    }
  },
  {
    "id": "major-12",
    "arcana": "major",
    "suit": "major",
    "number": 12,
    "rank": null,
    "sortOrder": 12,
    "names": {
      "en": "The Hanged Man",
      "es": "El Colgado"
    },
    "keywords": {
      "en": [
        "pause",
        "new perspective",
        "surrender",
        "suspension",
        "reframing"
      ],
      "es": [
        "pausa",
        "otra perspectiva",
        "entrega",
        "suspensión",
        "replantear"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:12",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/12.webp"
    }
  },
  {
    "id": "major-13",
    "arcana": "major",
    "suit": "major",
    "number": 13,
    "rank": null,
    "sortOrder": 13,
    "names": {
      "en": "Death",
      "es": "La Muerte"
    },
    "keywords": {
      "en": [
        "endings",
        "transformation",
        "letting go",
        "transition",
        "clearing"
      ],
      "es": [
        "finales",
        "transformación",
        "soltar",
        "transición",
        "despeje"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:13",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/13.webp"
    }
  },
  {
    "id": "major-14",
    "arcana": "major",
    "suit": "major",
    "number": 14,
    "rank": null,
    "sortOrder": 14,
    "names": {
      "en": "Temperance",
      "es": "La Templanza"
    },
    "keywords": {
      "en": [
        "balance",
        "moderation",
        "blending",
        "patience",
        "the middle path"
      ],
      "es": [
        "equilibrio",
        "moderación",
        "mezcla",
        "paciencia",
        "camino medio"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:14",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/14.webp"
    }
  },
  {
    "id": "major-15",
    "arcana": "major",
    "suit": "major",
    "number": 15,
    "rank": null,
    "sortOrder": 15,
    "names": {
      "en": "The Devil",
      "es": "El Diablo"
    },
    "keywords": {
      "en": [
        "attachment",
        "compulsion",
        "shadow",
        "materialism",
        "the trap you chose"
      ],
      "es": [
        "apego",
        "compulsión",
        "sombra",
        "materialismo",
        "la trampa elegida"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:15",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/15.webp"
    }
  },
  {
    "id": "major-16",
    "arcana": "major",
    "suit": "major",
    "number": 16,
    "rank": null,
    "sortOrder": 16,
    "names": {
      "en": "The Tower",
      "es": "La Torre"
    },
    "keywords": {
      "en": [
        "upheaval",
        "sudden change",
        "revelation",
        "collapse",
        "clearing ground"
      ],
      "es": [
        "sacudida",
        "cambio súbito",
        "revelación",
        "derrumbe",
        "terreno despejado"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:16",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/16.webp"
    }
  },
  {
    "id": "major-17",
    "arcana": "major",
    "suit": "major",
    "number": 17,
    "rank": null,
    "sortOrder": 17,
    "names": {
      "en": "The Star",
      "es": "La Estrella"
    },
    "keywords": {
      "en": [
        "hope",
        "renewal",
        "clarity",
        "healing",
        "quiet faith"
      ],
      "es": [
        "esperanza",
        "renovación",
        "claridad",
        "sanación",
        "fe callada"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:17",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/17.webp"
    }
  },
  {
    "id": "major-18",
    "arcana": "major",
    "suit": "major",
    "number": 18,
    "rank": null,
    "sortOrder": 18,
    "names": {
      "en": "The Moon",
      "es": "La Luna"
    },
    "keywords": {
      "en": [
        "uncertainty",
        "illusion",
        "the subconscious",
        "dreams",
        "half-light"
      ],
      "es": [
        "incertidumbre",
        "ilusión",
        "el subconsciente",
        "sueños",
        "media luz"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:18",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/18.webp"
    }
  },
  {
    "id": "major-19",
    "arcana": "major",
    "suit": "major",
    "number": 19,
    "rank": null,
    "sortOrder": 19,
    "names": {
      "en": "The Sun",
      "es": "El Sol"
    },
    "keywords": {
      "en": [
        "clarity",
        "vitality",
        "success",
        "warmth",
        "plain joy"
      ],
      "es": [
        "claridad",
        "vitalidad",
        "éxito",
        "calidez",
        "alegría simple"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:19",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/19.webp"
    }
  },
  {
    "id": "major-20",
    "arcana": "major",
    "suit": "major",
    "number": 20,
    "rank": null,
    "sortOrder": 20,
    "names": {
      "en": "Judgement",
      "es": "El Juicio"
    },
    "keywords": {
      "en": [
        "reckoning",
        "awakening",
        "calling",
        "evaluation",
        "rebirth"
      ],
      "es": [
        "ajuste de cuentas",
        "despertar",
        "llamado",
        "evaluación",
        "renacer"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:20",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/20.webp"
    }
  },
  {
    "id": "major-21",
    "arcana": "major",
    "suit": "major",
    "number": 21,
    "rank": null,
    "sortOrder": 21,
    "names": {
      "en": "The World",
      "es": "El Mundo"
    },
    "keywords": {
      "en": [
        "completion",
        "wholeness",
        "integration",
        "arrival",
        "closing the loop"
      ],
      "es": [
        "culminación",
        "totalidad",
        "integración",
        "llegada",
        "cerrar el círculo"
      ]
    },
    "tags": [
      "arcana:major",
      "suit:major",
      "number:21",
      "element:spirit"
    ],
    "art": {
      "rws": "/cards/rws/major/21.webp"
    }
  },
  {
    "id": "wands-1",
    "arcana": "minor",
    "suit": "wands",
    "number": 1,
    "rank": null,
    "sortOrder": 101,
    "names": {
      "en": "Ace of Wands",
      "es": "As de Bastos"
    },
    "keywords": {
      "en": [
        "spark",
        "inspiration",
        "new venture",
        "raw potential",
        "creative fire"
      ],
      "es": [
        "chispa",
        "inspiración",
        "nueva empresa",
        "potencial crudo",
        "fuego creativo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:1",
      "element:fire",
      "group:ace"
    ],
    "art": {
      "rws": "/cards/rws/wands/1.webp"
    }
  },
  {
    "id": "wands-2",
    "arcana": "minor",
    "suit": "wands",
    "number": 2,
    "rank": null,
    "sortOrder": 102,
    "names": {
      "en": "Two of Wands",
      "es": "Dos de Bastos"
    },
    "keywords": {
      "en": [
        "planning",
        "vision",
        "first move",
        "personal power",
        "deciding"
      ],
      "es": [
        "planificación",
        "visión",
        "primer movimiento",
        "poder personal",
        "decidir"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:2",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/2.webp"
    }
  },
  {
    "id": "wands-3",
    "arcana": "minor",
    "suit": "wands",
    "number": 3,
    "rank": null,
    "sortOrder": 103,
    "names": {
      "en": "Three of Wands",
      "es": "Tres de Bastos"
    },
    "keywords": {
      "en": [
        "expansion",
        "foresight",
        "progress",
        "momentum",
        "waiting on returns"
      ],
      "es": [
        "expansión",
        "previsión",
        "progreso",
        "impulso",
        "esperar el retorno"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:3",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/3.webp"
    }
  },
  {
    "id": "wands-4",
    "arcana": "minor",
    "suit": "wands",
    "number": 4,
    "rank": null,
    "sortOrder": 104,
    "names": {
      "en": "Four of Wands",
      "es": "Cuatro de Bastos"
    },
    "keywords": {
      "en": [
        "celebration",
        "milestone",
        "homecoming",
        "stability",
        "community"
      ],
      "es": [
        "celebración",
        "hito",
        "regreso a casa",
        "estabilidad",
        "comunidad"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:4",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/4.webp"
    }
  },
  {
    "id": "wands-5",
    "arcana": "minor",
    "suit": "wands",
    "number": 5,
    "rank": null,
    "sortOrder": 105,
    "names": {
      "en": "Five of Wands",
      "es": "Cinco de Bastos"
    },
    "keywords": {
      "en": [
        "friction",
        "competition",
        "scrappy conflict",
        "testing",
        "disagreement"
      ],
      "es": [
        "fricción",
        "competencia",
        "roce",
        "prueba",
        "desacuerdo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:5",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/5.webp"
    }
  },
  {
    "id": "wands-6",
    "arcana": "minor",
    "suit": "wands",
    "number": 6,
    "rank": null,
    "sortOrder": 106,
    "names": {
      "en": "Six of Wands",
      "es": "Seis de Bastos"
    },
    "keywords": {
      "en": [
        "recognition",
        "victory",
        "confidence",
        "good news",
        "public success"
      ],
      "es": [
        "reconocimiento",
        "victoria",
        "confianza",
        "buenas noticias",
        "éxito público"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:6",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/6.webp"
    }
  },
  {
    "id": "wands-7",
    "arcana": "minor",
    "suit": "wands",
    "number": 7,
    "rank": null,
    "sortOrder": 107,
    "names": {
      "en": "Seven of Wands",
      "es": "Siete de Bastos"
    },
    "keywords": {
      "en": [
        "standing your ground",
        "defence",
        "perseverance",
        "conviction",
        "challenge"
      ],
      "es": [
        "mantener posición",
        "defensa",
        "perseverancia",
        "convicción",
        "desafío"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:7",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/7.webp"
    }
  },
  {
    "id": "wands-8",
    "arcana": "minor",
    "suit": "wands",
    "number": 8,
    "rank": null,
    "sortOrder": 108,
    "names": {
      "en": "Eight of Wands",
      "es": "Ocho de Bastos"
    },
    "keywords": {
      "en": [
        "speed",
        "movement",
        "messages",
        "rapid change",
        "alignment"
      ],
      "es": [
        "velocidad",
        "movimiento",
        "mensajes",
        "cambio rápido",
        "alineación"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:8",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/8.webp"
    }
  },
  {
    "id": "wands-9",
    "arcana": "minor",
    "suit": "wands",
    "number": 9,
    "rank": null,
    "sortOrder": 109,
    "names": {
      "en": "Nine of Wands",
      "es": "Nueve de Bastos"
    },
    "keywords": {
      "en": [
        "resilience",
        "last stand",
        "stamina",
        "wariness",
        "boundaries"
      ],
      "es": [
        "resiliencia",
        "última defensa",
        "aguante",
        "recelo",
        "límites"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:9",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/9.webp"
    }
  },
  {
    "id": "wands-10",
    "arcana": "minor",
    "suit": "wands",
    "number": 10,
    "rank": null,
    "sortOrder": 110,
    "names": {
      "en": "Ten of Wands",
      "es": "Diez de Bastos"
    },
    "keywords": {
      "en": [
        "burden",
        "overload",
        "responsibility",
        "the grind",
        "carrying too much"
      ],
      "es": [
        "carga",
        "sobrecarga",
        "responsabilidad",
        "el desgaste",
        "cargar de más"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:10",
      "element:fire",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/wands/10.webp"
    }
  },
  {
    "id": "wands-11",
    "arcana": "minor",
    "suit": "wands",
    "number": 11,
    "rank": "page",
    "sortOrder": 111,
    "names": {
      "en": "Page of Wands",
      "es": "Sota de Bastos"
    },
    "keywords": {
      "en": [
        "curiosity",
        "enthusiasm",
        "exploration",
        "free spirit",
        "first attempt"
      ],
      "es": [
        "curiosidad",
        "entusiasmo",
        "exploración",
        "espíritu libre",
        "primer intento"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:11",
      "element:fire",
      "group:court",
      "court:page"
    ],
    "art": {
      "rws": "/cards/rws/wands/11.webp"
    }
  },
  {
    "id": "wands-12",
    "arcana": "minor",
    "suit": "wands",
    "number": 12,
    "rank": "knight",
    "sortOrder": 112,
    "names": {
      "en": "Knight of Wands",
      "es": "Caballo de Bastos"
    },
    "keywords": {
      "en": [
        "drive",
        "adventure",
        "passion",
        "haste",
        "charging in"
      ],
      "es": [
        "empuje",
        "aventura",
        "pasión",
        "prisa",
        "lanzarse"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:12",
      "element:fire",
      "group:court",
      "court:knight"
    ],
    "art": {
      "rws": "/cards/rws/wands/12.webp"
    }
  },
  {
    "id": "wands-13",
    "arcana": "minor",
    "suit": "wands",
    "number": 13,
    "rank": "queen",
    "sortOrder": 113,
    "names": {
      "en": "Queen of Wands",
      "es": "Reina de Bastos"
    },
    "keywords": {
      "en": [
        "magnetism",
        "confidence",
        "warmth",
        "determination",
        "self-assurance"
      ],
      "es": [
        "magnetismo",
        "confianza",
        "calidez",
        "determinación",
        "aplomo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:13",
      "element:fire",
      "group:court",
      "court:queen"
    ],
    "art": {
      "rws": "/cards/rws/wands/13.webp"
    }
  },
  {
    "id": "wands-14",
    "arcana": "minor",
    "suit": "wands",
    "number": 14,
    "rank": "king",
    "sortOrder": 114,
    "names": {
      "en": "King of Wands",
      "es": "Rey de Bastos"
    },
    "keywords": {
      "en": [
        "leadership",
        "vision",
        "boldness",
        "enterprise",
        "natural authority"
      ],
      "es": [
        "liderazgo",
        "visión",
        "audacia",
        "empresa",
        "autoridad natural"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:wands",
      "number:14",
      "element:fire",
      "group:court",
      "court:king"
    ],
    "art": {
      "rws": "/cards/rws/wands/14.webp"
    }
  },
  {
    "id": "cups-1",
    "arcana": "minor",
    "suit": "cups",
    "number": 1,
    "rank": null,
    "sortOrder": 201,
    "names": {
      "en": "Ace of Cups",
      "es": "As de Copas"
    },
    "keywords": {
      "en": [
        "new feeling",
        "emotional opening",
        "intuition",
        "compassion",
        "overflow"
      ],
      "es": [
        "sentimiento nuevo",
        "apertura emocional",
        "intuición",
        "compasión",
        "desbordar"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:1",
      "element:water",
      "group:ace"
    ],
    "art": {
      "rws": "/cards/rws/cups/1.webp"
    }
  },
  {
    "id": "cups-2",
    "arcana": "minor",
    "suit": "cups",
    "number": 2,
    "rank": null,
    "sortOrder": 202,
    "names": {
      "en": "Two of Cups",
      "es": "Dos de Copas"
    },
    "keywords": {
      "en": [
        "partnership",
        "mutual regard",
        "union",
        "connection",
        "truce"
      ],
      "es": [
        "asociación",
        "aprecio mutuo",
        "unión",
        "conexión",
        "tregua"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:2",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/2.webp"
    }
  },
  {
    "id": "cups-3",
    "arcana": "minor",
    "suit": "cups",
    "number": 3,
    "rank": null,
    "sortOrder": 203,
    "names": {
      "en": "Three of Cups",
      "es": "Tres de Copas"
    },
    "keywords": {
      "en": [
        "friendship",
        "celebration",
        "community",
        "joy",
        "reunion"
      ],
      "es": [
        "amistad",
        "celebración",
        "comunidad",
        "alegría",
        "reencuentro"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:3",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/3.webp"
    }
  },
  {
    "id": "cups-4",
    "arcana": "minor",
    "suit": "cups",
    "number": 4,
    "rank": null,
    "sortOrder": 204,
    "names": {
      "en": "Four of Cups",
      "es": "Cuatro de Copas"
    },
    "keywords": {
      "en": [
        "apathy",
        "contemplation",
        "boredom",
        "re-evaluation",
        "the missed offer"
      ],
      "es": [
        "apatía",
        "contemplación",
        "hastío",
        "reevaluación",
        "la oferta ignorada"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:4",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/4.webp"
    }
  },
  {
    "id": "cups-5",
    "arcana": "minor",
    "suit": "cups",
    "number": 5,
    "rank": null,
    "sortOrder": 205,
    "names": {
      "en": "Five of Cups",
      "es": "Cinco de Copas"
    },
    "keywords": {
      "en": [
        "grief",
        "loss",
        "regret",
        "mourning",
        "what remains"
      ],
      "es": [
        "duelo",
        "pérdida",
        "arrepentimiento",
        "luto",
        "lo que queda"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:5",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/5.webp"
    }
  },
  {
    "id": "cups-6",
    "arcana": "minor",
    "suit": "cups",
    "number": 6,
    "rank": null,
    "sortOrder": 206,
    "names": {
      "en": "Six of Cups",
      "es": "Seis de Copas"
    },
    "keywords": {
      "en": [
        "nostalgia",
        "memory",
        "innocence",
        "familiar comfort",
        "the past"
      ],
      "es": [
        "nostalgia",
        "memoria",
        "inocencia",
        "consuelo familiar",
        "el pasado"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:6",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/6.webp"
    }
  },
  {
    "id": "cups-7",
    "arcana": "minor",
    "suit": "cups",
    "number": 7,
    "rank": null,
    "sortOrder": 207,
    "names": {
      "en": "Seven of Cups",
      "es": "Siete de Copas"
    },
    "keywords": {
      "en": [
        "choices",
        "fantasy",
        "illusion",
        "too many options",
        "wishful thinking"
      ],
      "es": [
        "opciones",
        "fantasía",
        "ilusión",
        "demasiadas puertas",
        "ilusionarse"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:7",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/7.webp"
    }
  },
  {
    "id": "cups-8",
    "arcana": "minor",
    "suit": "cups",
    "number": 8,
    "rank": null,
    "sortOrder": 208,
    "names": {
      "en": "Eight of Cups",
      "es": "Ocho de Copas"
    },
    "keywords": {
      "en": [
        "walking away",
        "seeking meaning",
        "departure",
        "disillusionment",
        "moving on"
      ],
      "es": [
        "marcharse",
        "buscar sentido",
        "partida",
        "desencanto",
        "seguir adelante"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:8",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/8.webp"
    }
  },
  {
    "id": "cups-9",
    "arcana": "minor",
    "suit": "cups",
    "number": 9,
    "rank": null,
    "sortOrder": 209,
    "names": {
      "en": "Nine of Cups",
      "es": "Nueve de Copas"
    },
    "keywords": {
      "en": [
        "satisfaction",
        "wish granted",
        "contentment",
        "indulgence",
        "gratitude"
      ],
      "es": [
        "satisfacción",
        "deseo cumplido",
        "contento",
        "indulgencia",
        "gratitud"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:9",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/9.webp"
    }
  },
  {
    "id": "cups-10",
    "arcana": "minor",
    "suit": "cups",
    "number": 10,
    "rank": null,
    "sortOrder": 210,
    "names": {
      "en": "Ten of Cups",
      "es": "Diez de Copas"
    },
    "keywords": {
      "en": [
        "harmony",
        "belonging",
        "family",
        "emotional fulfilment",
        "lasting joy"
      ],
      "es": [
        "armonía",
        "pertenencia",
        "familia",
        "plenitud emocional",
        "alegría duradera"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:10",
      "element:water",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/cups/10.webp"
    }
  },
  {
    "id": "cups-11",
    "arcana": "minor",
    "suit": "cups",
    "number": 11,
    "rank": "page",
    "sortOrder": 211,
    "names": {
      "en": "Page of Cups",
      "es": "Sota de Copas"
    },
    "keywords": {
      "en": [
        "sensitivity",
        "wonder",
        "creative message",
        "openness",
        "intuition"
      ],
      "es": [
        "sensibilidad",
        "asombro",
        "mensaje creativo",
        "apertura",
        "intuición"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:11",
      "element:water",
      "group:court",
      "court:page"
    ],
    "art": {
      "rws": "/cards/rws/cups/11.webp"
    }
  },
  {
    "id": "cups-12",
    "arcana": "minor",
    "suit": "cups",
    "number": 12,
    "rank": "knight",
    "sortOrder": 212,
    "names": {
      "en": "Knight of Cups",
      "es": "Caballo de Copas"
    },
    "keywords": {
      "en": [
        "romance",
        "invitation",
        "idealism",
        "following the heart",
        "charm"
      ],
      "es": [
        "romance",
        "invitación",
        "idealismo",
        "seguir al corazón",
        "encanto"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:12",
      "element:water",
      "group:court",
      "court:knight"
    ],
    "art": {
      "rws": "/cards/rws/cups/12.webp"
    }
  },
  {
    "id": "cups-13",
    "arcana": "minor",
    "suit": "cups",
    "number": 13,
    "rank": "queen",
    "sortOrder": 213,
    "names": {
      "en": "Queen of Cups",
      "es": "Reina de Copas"
    },
    "keywords": {
      "en": [
        "empathy",
        "emotional depth",
        "intuition",
        "care",
        "holding space"
      ],
      "es": [
        "empatía",
        "hondura emocional",
        "intuición",
        "cuidado",
        "sostener el espacio"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:13",
      "element:water",
      "group:court",
      "court:queen"
    ],
    "art": {
      "rws": "/cards/rws/cups/13.webp"
    }
  },
  {
    "id": "cups-14",
    "arcana": "minor",
    "suit": "cups",
    "number": 14,
    "rank": "king",
    "sortOrder": 214,
    "names": {
      "en": "King of Cups",
      "es": "Rey de Copas"
    },
    "keywords": {
      "en": [
        "emotional balance",
        "wisdom",
        "diplomacy",
        "steadiness",
        "compassionate control"
      ],
      "es": [
        "equilibrio emocional",
        "sabiduría",
        "diplomacia",
        "temple",
        "control compasivo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:cups",
      "number:14",
      "element:water",
      "group:court",
      "court:king"
    ],
    "art": {
      "rws": "/cards/rws/cups/14.webp"
    }
  },
  {
    "id": "swords-1",
    "arcana": "minor",
    "suit": "swords",
    "number": 1,
    "rank": null,
    "sortOrder": 301,
    "names": {
      "en": "Ace of Swords",
      "es": "As de Espadas"
    },
    "keywords": {
      "en": [
        "clarity",
        "breakthrough",
        "truth",
        "sharp insight",
        "the new idea"
      ],
      "es": [
        "claridad",
        "avance",
        "verdad",
        "lucidez",
        "la idea nueva"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:1",
      "element:air",
      "group:ace"
    ],
    "art": {
      "rws": "/cards/rws/swords/1.webp"
    }
  },
  {
    "id": "swords-2",
    "arcana": "minor",
    "suit": "swords",
    "number": 2,
    "rank": null,
    "sortOrder": 302,
    "names": {
      "en": "Two of Swords",
      "es": "Dos de Espadas"
    },
    "keywords": {
      "en": [
        "stalemate",
        "avoidance",
        "hard choice",
        "uneasy truce",
        "blindfolded"
      ],
      "es": [
        "punto muerto",
        "evasión",
        "elección difícil",
        "tregua incómoda",
        "con los ojos vendados"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:2",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/2.webp"
    }
  },
  {
    "id": "swords-3",
    "arcana": "minor",
    "suit": "swords",
    "number": 3,
    "rank": null,
    "sortOrder": 303,
    "names": {
      "en": "Three of Swords",
      "es": "Tres de Espadas"
    },
    "keywords": {
      "en": [
        "heartbreak",
        "painful truth",
        "grief",
        "betrayal",
        "the necessary cut"
      ],
      "es": [
        "desamor",
        "verdad dolorosa",
        "duelo",
        "traición",
        "el corte necesario"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:3",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/3.webp"
    }
  },
  {
    "id": "swords-4",
    "arcana": "minor",
    "suit": "swords",
    "number": 4,
    "rank": null,
    "sortOrder": 304,
    "names": {
      "en": "Four of Swords",
      "es": "Cuatro de Espadas"
    },
    "keywords": {
      "en": [
        "rest",
        "recovery",
        "retreat",
        "pause",
        "mental reset"
      ],
      "es": [
        "descanso",
        "recuperación",
        "retiro",
        "pausa",
        "reinicio mental"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:4",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/4.webp"
    }
  },
  {
    "id": "swords-5",
    "arcana": "minor",
    "suit": "swords",
    "number": 5,
    "rank": null,
    "sortOrder": 305,
    "names": {
      "en": "Five of Swords",
      "es": "Cinco de Espadas"
    },
    "keywords": {
      "en": [
        "hollow victory",
        "discord",
        "pride",
        "winning badly",
        "conflict"
      ],
      "es": [
        "victoria hueca",
        "discordia",
        "orgullo",
        "ganar mal",
        "conflicto"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:5",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/5.webp"
    }
  },
  {
    "id": "swords-6",
    "arcana": "minor",
    "suit": "swords",
    "number": 6,
    "rank": null,
    "sortOrder": 306,
    "names": {
      "en": "Six of Swords",
      "es": "Seis de Espadas"
    },
    "keywords": {
      "en": [
        "transition",
        "safe passage",
        "moving on",
        "leaving behind",
        "gradual healing"
      ],
      "es": [
        "transición",
        "travesía segura",
        "seguir adelante",
        "dejar atrás",
        "sanar despacio"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:6",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/6.webp"
    }
  },
  {
    "id": "swords-7",
    "arcana": "minor",
    "suit": "swords",
    "number": 7,
    "rank": null,
    "sortOrder": 307,
    "names": {
      "en": "Seven of Swords",
      "es": "Siete de Espadas"
    },
    "keywords": {
      "en": [
        "strategy",
        "stealth",
        "cunning",
        "deception",
        "acting alone"
      ],
      "es": [
        "estrategia",
        "sigilo",
        "astucia",
        "engaño",
        "actuar en solitario"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:7",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/7.webp"
    }
  },
  {
    "id": "swords-8",
    "arcana": "minor",
    "suit": "swords",
    "number": 8,
    "rank": null,
    "sortOrder": 308,
    "names": {
      "en": "Eight of Swords",
      "es": "Ocho de Espadas"
    },
    "keywords": {
      "en": [
        "feeling trapped",
        "self-limiting belief",
        "paralysis",
        "restriction",
        "powerlessness"
      ],
      "es": [
        "sentirse atrapado",
        "creencias que limitan",
        "parálisis",
        "restricción",
        "impotencia"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:8",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/8.webp"
    }
  },
  {
    "id": "swords-9",
    "arcana": "minor",
    "suit": "swords",
    "number": 9,
    "rank": null,
    "sortOrder": 309,
    "names": {
      "en": "Nine of Swords",
      "es": "Nueve de Espadas"
    },
    "keywords": {
      "en": [
        "anxiety",
        "worry",
        "sleeplessness",
        "the mental spiral",
        "dread"
      ],
      "es": [
        "ansiedad",
        "preocupación",
        "insomnio",
        "la espiral mental",
        "angustia"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:9",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/9.webp"
    }
  },
  {
    "id": "swords-10",
    "arcana": "minor",
    "suit": "swords",
    "number": 10,
    "rank": null,
    "sortOrder": 310,
    "names": {
      "en": "Ten of Swords",
      "es": "Diez de Espadas"
    },
    "keywords": {
      "en": [
        "rock bottom",
        "ending",
        "collapse",
        "betrayal",
        "the worst is over"
      ],
      "es": [
        "tocar fondo",
        "final",
        "derrumbe",
        "traición",
        "lo peor ya pasó"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:10",
      "element:air",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/swords/10.webp"
    }
  },
  {
    "id": "swords-11",
    "arcana": "minor",
    "suit": "swords",
    "number": 11,
    "rank": "page",
    "sortOrder": 311,
    "names": {
      "en": "Page of Swords",
      "es": "Sota de Espadas"
    },
    "keywords": {
      "en": [
        "curiosity",
        "watchfulness",
        "new information",
        "questions",
        "mental energy"
      ],
      "es": [
        "curiosidad",
        "vigilancia",
        "información nueva",
        "preguntas",
        "energía mental"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:11",
      "element:air",
      "group:court",
      "court:page"
    ],
    "art": {
      "rws": "/cards/rws/swords/11.webp"
    }
  },
  {
    "id": "swords-12",
    "arcana": "minor",
    "suit": "swords",
    "number": 12,
    "rank": "knight",
    "sortOrder": 312,
    "names": {
      "en": "Knight of Swords",
      "es": "Caballo de Espadas"
    },
    "keywords": {
      "en": [
        "urgency",
        "blunt force",
        "argument",
        "charging in",
        "conviction"
      ],
      "es": [
        "urgencia",
        "fuerza bruta",
        "discusión",
        "lanzarse",
        "convicción"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:12",
      "element:air",
      "group:court",
      "court:knight"
    ],
    "art": {
      "rws": "/cards/rws/swords/12.webp"
    }
  },
  {
    "id": "swords-13",
    "arcana": "minor",
    "suit": "swords",
    "number": 13,
    "rank": "queen",
    "sortOrder": 313,
    "names": {
      "en": "Queen of Swords",
      "es": "Reina de Espadas"
    },
    "keywords": {
      "en": [
        "clear judgement",
        "honesty",
        "independence",
        "perception",
        "boundaries"
      ],
      "es": [
        "juicio claro",
        "honestidad",
        "independencia",
        "percepción",
        "límites"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:13",
      "element:air",
      "group:court",
      "court:queen"
    ],
    "art": {
      "rws": "/cards/rws/swords/13.webp"
    }
  },
  {
    "id": "swords-14",
    "arcana": "minor",
    "suit": "swords",
    "number": 14,
    "rank": "king",
    "sortOrder": 314,
    "names": {
      "en": "King of Swords",
      "es": "Rey de Espadas"
    },
    "keywords": {
      "en": [
        "authority",
        "intellect",
        "ethics",
        "judgement",
        "principled command"
      ],
      "es": [
        "autoridad",
        "intelecto",
        "ética",
        "juicio",
        "mando con principios"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:swords",
      "number:14",
      "element:air",
      "group:court",
      "court:king"
    ],
    "art": {
      "rws": "/cards/rws/swords/14.webp"
    }
  },
  {
    "id": "pentacles-1",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 1,
    "rank": null,
    "sortOrder": 401,
    "names": {
      "en": "Ace of Pentacles",
      "es": "As de Oros"
    },
    "keywords": {
      "en": [
        "opportunity",
        "tangible start",
        "prosperity",
        "the seed",
        "manifestation"
      ],
      "es": [
        "oportunidad",
        "arranque tangible",
        "prosperidad",
        "la semilla",
        "manifestación"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:1",
      "element:earth",
      "group:ace"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/1.webp"
    }
  },
  {
    "id": "pentacles-2",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 2,
    "rank": null,
    "sortOrder": 402,
    "names": {
      "en": "Two of Pentacles",
      "es": "Dos de Oros"
    },
    "keywords": {
      "en": [
        "juggling",
        "balance",
        "adaptability",
        "cash flow",
        "priorities"
      ],
      "es": [
        "malabares",
        "equilibrio",
        "adaptabilidad",
        "flujo de caja",
        "prioridades"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:2",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/2.webp"
    }
  },
  {
    "id": "pentacles-3",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 3,
    "rank": null,
    "sortOrder": 403,
    "names": {
      "en": "Three of Pentacles",
      "es": "Tres de Oros"
    },
    "keywords": {
      "en": [
        "collaboration",
        "craftsmanship",
        "skill",
        "teamwork",
        "apprenticeship"
      ],
      "es": [
        "colaboración",
        "oficio",
        "destreza",
        "trabajo en equipo",
        "aprendizaje"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:3",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/3.webp"
    }
  },
  {
    "id": "pentacles-4",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 4,
    "rank": null,
    "sortOrder": 404,
    "names": {
      "en": "Four of Pentacles",
      "es": "Cuatro de Oros"
    },
    "keywords": {
      "en": [
        "holding on",
        "security",
        "control",
        "saving",
        "scarcity thinking"
      ],
      "es": [
        "aferrarse",
        "seguridad",
        "control",
        "ahorro",
        "mentalidad de escasez"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:4",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/4.webp"
    }
  },
  {
    "id": "pentacles-5",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 5,
    "rank": null,
    "sortOrder": 405,
    "names": {
      "en": "Five of Pentacles",
      "es": "Cinco de Oros"
    },
    "keywords": {
      "en": [
        "hardship",
        "exclusion",
        "want",
        "insecurity",
        "help nearby"
      ],
      "es": [
        "carencia",
        "exclusión",
        "necesidad",
        "inseguridad",
        "la ayuda cercana"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:5",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/5.webp"
    }
  },
  {
    "id": "pentacles-6",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 6,
    "rank": null,
    "sortOrder": 406,
    "names": {
      "en": "Six of Pentacles",
      "es": "Seis de Oros"
    },
    "keywords": {
      "en": [
        "generosity",
        "giving and receiving",
        "support",
        "fairness",
        "patronage"
      ],
      "es": [
        "generosidad",
        "dar y recibir",
        "apoyo",
        "justicia",
        "mecenazgo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:6",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/6.webp"
    }
  },
  {
    "id": "pentacles-7",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 7,
    "rank": null,
    "sortOrder": 407,
    "names": {
      "en": "Seven of Pentacles",
      "es": "Siete de Oros"
    },
    "keywords": {
      "en": [
        "patience",
        "the long game",
        "assessment",
        "investment",
        "waiting on growth"
      ],
      "es": [
        "paciencia",
        "el juego largo",
        "evaluación",
        "inversión",
        "esperar la cosecha"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:7",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/7.webp"
    }
  },
  {
    "id": "pentacles-8",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 8,
    "rank": null,
    "sortOrder": 408,
    "names": {
      "en": "Eight of Pentacles",
      "es": "Ocho de Oros"
    },
    "keywords": {
      "en": [
        "practice",
        "craft",
        "diligence",
        "mastery in progress",
        "repetition"
      ],
      "es": [
        "práctica",
        "oficio",
        "constancia",
        "maestría en curso",
        "repetición"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:8",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/8.webp"
    }
  },
  {
    "id": "pentacles-9",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 9,
    "rank": null,
    "sortOrder": 409,
    "names": {
      "en": "Nine of Pentacles",
      "es": "Nueve de Oros"
    },
    "keywords": {
      "en": [
        "self-sufficiency",
        "earned comfort",
        "independence",
        "refinement",
        "enjoying it"
      ],
      "es": [
        "autosuficiencia",
        "bienestar ganado",
        "independencia",
        "refinamiento",
        "disfrutarlo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:9",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/9.webp"
    }
  },
  {
    "id": "pentacles-10",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 10,
    "rank": null,
    "sortOrder": 410,
    "names": {
      "en": "Ten of Pentacles",
      "es": "Diez de Oros"
    },
    "keywords": {
      "en": [
        "legacy",
        "foundations",
        "wealth",
        "permanence",
        "inheritance"
      ],
      "es": [
        "legado",
        "cimientos",
        "riqueza",
        "permanencia",
        "herencia"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:10",
      "element:earth",
      "group:pip"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/10.webp"
    }
  },
  {
    "id": "pentacles-11",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 11,
    "rank": "page",
    "sortOrder": 411,
    "names": {
      "en": "Page of Pentacles",
      "es": "Sota de Oros"
    },
    "keywords": {
      "en": [
        "study",
        "new skill",
        "practical curiosity",
        "ambition",
        "groundwork"
      ],
      "es": [
        "estudio",
        "destreza nueva",
        "curiosidad práctica",
        "ambición",
        "cimentar"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:11",
      "element:earth",
      "group:court",
      "court:page"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/11.webp"
    }
  },
  {
    "id": "pentacles-12",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 12,
    "rank": "knight",
    "sortOrder": 412,
    "names": {
      "en": "Knight of Pentacles",
      "es": "Caballo de Oros"
    },
    "keywords": {
      "en": [
        "reliability",
        "routine",
        "patience",
        "method",
        "unglamorous progress"
      ],
      "es": [
        "fiabilidad",
        "rutina",
        "paciencia",
        "método",
        "avance sin brillo"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:12",
      "element:earth",
      "group:court",
      "court:knight"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/12.webp"
    }
  },
  {
    "id": "pentacles-13",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 13,
    "rank": "queen",
    "sortOrder": 413,
    "names": {
      "en": "Queen of Pentacles",
      "es": "Reina de Oros"
    },
    "keywords": {
      "en": [
        "nurture",
        "practicality",
        "resourcefulness",
        "grounded care",
        "abundance"
      ],
      "es": [
        "cuidado",
        "practicidad",
        "recursos",
        "cuidado con los pies en la tierra",
        "abundancia"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:13",
      "element:earth",
      "group:court",
      "court:queen"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/13.webp"
    }
  },
  {
    "id": "pentacles-14",
    "arcana": "minor",
    "suit": "pentacles",
    "number": 14,
    "rank": "king",
    "sortOrder": 414,
    "names": {
      "en": "King of Pentacles",
      "es": "Rey de Oros"
    },
    "keywords": {
      "en": [
        "mastery",
        "stability",
        "discipline",
        "provision",
        "material command"
      ],
      "es": [
        "maestría",
        "estabilidad",
        "disciplina",
        "provisión",
        "mando material"
      ]
    },
    "tags": [
      "arcana:minor",
      "suit:pentacles",
      "number:14",
      "element:earth",
      "group:court",
      "court:king"
    ],
    "art": {
      "rws": "/cards/rws/pentacles/14.webp"
    }
  }
]
